import type { DocumentTypeName } from '@/features/documents/constants';

export type WorkspaceType = Extract<DocumentTypeName, 'tenderPackage' | 'contract'>;

export const WORKSPACES_VIEWS = ['list', 'board'] as const;
export const WORKSPACE_OVERVIEW_TABS = [
  'brief',
  'awardCriteria',
  'submissionRequirements',
] as const;

export const WORKSPACE_TYPES = ['tenderPackage', 'contract'] as const;

export type WorkspaceCreatorType = 'client' | 'supplier';

export enum AnalysisStatus {
  FAILED = -20,
  NOT_STARTED = 0,
  IN_PROGRESS = 10,
  NOT_FOUND = 15,
  DONE = 20,
}

export const ANALYSIS_TERMINAL_STATUSES: readonly AnalysisStatus[] = [
  AnalysisStatus.DONE,
  AnalysisStatus.FAILED,
  AnalysisStatus.NOT_FOUND,
];

export type AssessmentType = Extract<DocumentTypeName, 'tenderPackage' | 'contract' | 'bid'>;

export type SummaryType = Extract<
  DocumentTypeName,
  'bid' | 'tenderPackage' | 'contract' | 'supplement' | 'tenderFeedback'
>;

export enum AnalysisTypes {
  BID_DRAFTING = 'BID_DRAFTING',
  CONFLICTS = 'segmentInconsistencies',
  DEVIATIONS = 'deviations',
  AMBIGUITIES = 'ambiguities',
  BID_METHODOLOGY = 'bidQuality',
  CV_ASSESSMENT = 'cvAssessment',
  TENDER_FEEDBACK_POSITIVES_NEGATIVES = 'tenderFeedbackPositivesNegatives',
  CLAUSE_SCANNER = 'clauseScanner',
  LEGAL_DEVIATIONS = 'legalDeviations',
  SUBCONTRACTOR_LEVELING = 'subcontractorLeveling',
  SUBCONTRACTOR_RFP_DRAFT = 'subcontractorRfpDraft',
  KG_REBUILD = 'tenderKgRebuild',
  BID_COMPLIANCE = 'bidCompliance',
}

export const REFETCH_SUMMARIZATION_INTERVAL = 8;
